if (!customElements.get('delivery-estimation')) {
    customElements.define(
        'delivery-estimation',
        class DeliveryEstimation extends HTMLElement {
            constructor() {
                super();

                this.deliverySelectors = {
                    container: '.delivery-estimation__container',
                    delayContainer: '.delivery-estimation__delay-container',
                    minimumDelay: '#datemin',
                    maximumDelay: '#datemax',
                    countdown: '#countdown',
                };

                this.deliveryDelayContainer = this.querySelector(this.deliverySelectors.delayContainer);
                this.deliveryMinimumDelay = this.querySelector(this.deliverySelectors.minimumDelay);
                this.deliveryMaximumDelay = this.querySelector(this.deliverySelectors.maximumDelay);
                this.countdown = this.querySelector(this.deliverySelectors.countdown);

                this.translation = JSON.parse(this.querySelector('[type="application/json"]').textContent);

                this.stock = {
                    available: this.translation.stock_available,
                    low: this.translation.stock_low,
                };

                this.date_format = this.translation.date_format;

                this.CSSClass = {
                    available: 'stock-indic--available',
                    low: 'stock-indic--low',
                    out: 'stock-indic--out',
                };

                this.variantElms = document.querySelectorAll('.product-variant');
                this.currentVariantId = this.querySelector('.stock-disp-cont').dataset.currentVariantId;
            }

            connectedCallback() {
                this.init();
                this.listenEvents();
            }

            listenEvents() {
                document.addEventListener('variant:change', (event) => {
                    this.currentVariantId = event.detail.variant.id;
                    this.init();
                });
            }

            init() {
                this.variantsObj = [];

                this.variantElms.forEach((variantElm) => {
                    this.variantsObj.push({
                        id: variantElm.dataset.variantId,
                        inventory_qty: variantElm.dataset.variantInventoryQty,
                    });
                });

                const varIndex = this.variantsObj.findIndex((o) => parseInt(o.id) === parseInt(this.currentVariantId));
                const varQuantity = parseInt(this.variantsObj[varIndex].inventory_qty);
                const stockDisp = document.querySelector('.stock-disp');
                const stockIndic = document.querySelector('.stock-indic');

                if (stockIndic && stockDisp) {
                    if (stockIndic.classList.contains(this.CSSClass.low)) {
                        stockIndic.classList.remove(this.CSSClass.low);
                    }
                    if (stockIndic.classList.contains(this.CSSClass.out)) {
                        stockIndic.classList.remove(this.CSSClass.out);
                    }
                    if (stockIndic.classList.contains(this.CSSClass.available)) {
                        stockIndic.classList.remove(this.CSSClass.available);
                    }

                    if (varQuantity >= 20) {
                        stockDisp.innerHTML = this.translation.available;
                        stockIndic.classList.add(this.CSSClass.available);
                    } else if (varQuantity < 20 && varQuantity > 0) {
                        stockDisp.innerHTML = `${this.translation.low_before} ${varQuantity} ${this.translation.low_after}`;
                        stockIndic.classList.add(this.CSSClass.low);
                    } else if (varQuantity <= 0) {
                        stockDisp.innerHTML = `${this.translation.unavailable}`;
                        stockIndic.classList.add(this.CSSClass.out);
                    }
                }

                this.updateDeliveryDelay();

                if (this.countdown) {
                    this.startCountdown();
                }
            }

            updateDeliveryDelay() {
                let today = new Date();
                let datesDelai;

                if (this.deliveryDelayContainer.dataset.max === '0') {
                    datesDelai = this.getDatesDelai(today, parseInt(this.deliveryDelayContainer.dataset.min));
                } else {
                    datesDelai = this.getDatesDelai(today, parseInt(this.deliveryDelayContainer.dataset.min), parseInt(this.deliveryDelayContainer.dataset.max));
                }

                this.deliveryMinimumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmin']);

                if (this.deliveryDelayContainer.dataset.max !== '0') {
                    this.deliveryMaximumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmax']);
                }
            }

            dateFrenchFormat(dateAConvertir) {
                var jours = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
                var mois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

                var date = new Date(dateAConvertir);
                var day = date.getDate();

                if (date.getDay() === 0) {
                    // Dimanche
                    day = date.setDate(date.getDate() + 1);
                }

                if (this.date_format === 'lettres') {
                    var jourIndex = date.getDay();
                    var message = jours[jourIndex] + ' ';
                    message += day + ' ';
                    message += mois[date.getMonth()] + ' ';
                } else {
                    var message = date.getDate() + '/';
                    message += date.getMonth() + 1 + '/';
                    message += date.getFullYear();
                }
                return message;
            }

            getDatesDelai(date1, delaiMin, delaiMax = delaiMin) {
                var result = {};
                var startDate = new Date(date1);
                var currentTime = this.getCurrentTimeInFrance();

                // Si on est le vendredi après 12h, ajuster le délai minimum au lundi suivant
                if (startDate.getDay() === 5 && currentTime.getHours() >= 12) { // 5 = Vendredi
                    startDate.setDate(startDate.getDate() + (8 - startDate.getDay())); // Passer au lundi suivant
                    startDate = this.adjustDateForWeekend(startDate);
                } else {
                    startDate = this.adjustDateForWeekend(startDate);
                }

                // Calcul de la date de fin minimale
                var minEndDate = new Date(startDate);
                if (currentTime.getDay() === 5 && currentTime.getHours() >= 12 || currentTime.getHours() < 12)
                    minEndDate = this.addBusinessDays(minEndDate, delaiMin);
                else
                    minEndDate = this.addBusinessDays(minEndDate, delaiMin + 1);

                // Calcul de la date de fin maximale
                var maxEndDate = new Date(minEndDate);
                maxEndDate = this.addBusinessDays(maxEndDate, delaiMax - 1);

                result['dmin'] = minEndDate;
                result['dmax'] = maxEndDate;

                return result;
            }

            addBusinessDays(startDate, numberOfBusinessDays) {
                var date = new Date(startDate.getTime());
                while (numberOfBusinessDays > 0) {
                    date.setDate(date.getDate() + 1);
                    // Diminue le nombre de jours uniquement pour les jours de semaine
                    if (date.getDay() !== 0) { // 0 = Dimanche
                        numberOfBusinessDays--;
                    }
                }
                return date;
            }

            adjustDateForWeekend(date) {
                var adjustedDate = new Date(date.getTime());
                // Si la date est dimanche, ajuster au lundi suivant
                if (adjustedDate.getDay() === 0) {
                    // 0: Dimanche, passer au lundi
                    adjustedDate.setDate(adjustedDate.getDate() + 1);
                }
                return adjustedDate;
            }

            checkIfIsValidDate(d) {
                return Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime()) ? true : false;
            }

            startCountdown() {
                const targetTime = this.getTargetTimeInFrance();
                const currentTime = this.getCurrentTimeInFrance();
                const timeRemaining = this.getTimeDifferenceInMs(targetTime, currentTime);

                this.countdown.innerHTML = this.formatDuration(timeRemaining);
            }

            getCurrentTimeInFrance() {
                const FRANCE_UTC_OFFSET = 120;
                const today = new Date();
                const localOffset = today.getTimezoneOffset();
                const franceTime = new Date(today.getTime() + (FRANCE_UTC_OFFSET + localOffset) * 60000);
                return franceTime;
            }

            getTargetTimeInFrance() {
                const now = this.getCurrentTimeInFrance();
                const noonToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
                if (now < noonToday) {
                    return noonToday;
                } else {
                    const noonTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12, 0, 0);
                    return noonTomorrow;
                }
            }

            getTimeDifferenceInMs(date1, date2) {
                return Math.abs(date1.getTime() - date2.getTime());
            }

            formatDuration(durationInMs) {
                const hours = Math.floor(durationInMs / (1000 * 60 * 60));
                const minutes = Math.floor((durationInMs % (1000 * 60 * 60)) / (1000 * 60));
                return `${hours} heures, ${minutes} minutes`;
            }
        }
    );
}
